// função que efetua validação do CPF
export function getText(value, object) {
  // RETORNA O DESCRITIVO DO CAMPO
  if (!object.options) {
    console.log('Metadata "options" não foi encontrado:')
    console.log(object)
    return ''
  }
  var item = object.options.filter(x => x.id === value);
  if (item.length) { return item[0].text }
}

export function formatDate(dateField) {
  //RECEBE A DATA NO FORMATO JSON "2018-09-21T03:00:00Z" E RETORNA NO FORMATO BR 21/09/2018

  if (checkDate(dateField)) {
    const [year_, month_, day_] = dateField.split("-")
    var day = day_.substr(0, 2)

    return [day, month_, year_].join('-')
  }
  else {
    return dateField
  }
}

export function formatDateTraco(dateField) {
  //RECEBE A DATA NO FORMATO JSON "2018-09-21T03:00:00Z" E RETORNA NO FORMATO BR 21/09/2018
  if (checkDate(dateField)) {
    const [year_, month_, day_] = dateField.split("-")
    var day = day_.substr(0, 2)

    return [day, month_, year_].join('-')
  }
  else {
    return dateField
  }
}

export function checkDate(field) {
  if (field != '') {
    //https://stackoverflow.com/questions/29826284/my-regex-does-not-match-yyyy-mm-ddthhmmss


    // if ((/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z$/.test(field))
    if ((/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])$/.test(field))
      ||
      (/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z$/.test(field))
      ||
      (/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])(00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9])$/.test(field))
      ||
      (/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/.test(field))) {
      return true
    }
    else {
      return false
    }
  }
  else {
    return false
  }
}

export function stringToInteger(str) {
  // Attempt to parse the string to an integer
  const parsedInt = parseInt(str, 10);

  // Check if the result is NaN (Not a Number)
  if (isNaN(parsedInt)) {
    return 0; // Return 0 if parsing fails
  }

  return parsedInt; // Return the parsed integer
}

export function formatValue(value, precision) {
  var numero = 0;
  if (value) {
    numero = value
  }

  numero = parseFloat(numero).toFixed(precision).split('.')
  if (numero) {
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.')

    //RETIRA O PONTO A FRENTE DE VALORES NEGATIVOS
    if (numero[0].substr(0, 1) === '-') {
      let fracao = numero[0].split('')
      if (fracao[1] === '.') {
        fracao.splice(1, 1)
        fracao = fracao.join('')
        numero[0] = fracao
      }

    }
    return numero.join(',')
  }
  else {
    return 0
  }
  // let numero = 0
  // if (value)
  //   numero = value
  // numero = numero.toLocaleString('pt-br', {minimumFractionDigits: 2})
  // return numero

}

export function formatCNPJCPF(value) {
  if (!value) {
    return value
  }
  if (value.length == 14) {
    return String(value).toUpperCase().replace(/^([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?([A-Z0-9]{2})?/, "$1.$2.$3/$4-$5")
  }
  if (value.length == 11) {
    return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4")
  } else {
    return value
  }
}

export function formatFone(value) {
  if (!value) {
    return value
  }
  let t = value.length
  if (t == 8)
    return value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})??/, "$1-$2")
  else
    if (t == 9)
      return value.replace(/\D/g, '').replace(/^(\d{1})(\d{4})(\d{4})??/, "$1 $2-$3")
    else
      if (t == 11)
        return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})(\d{4})(\d{4})??/, "($1) $2 $3-$4")
      else
        if (t == 10)
          return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4})??/, "($1) $2-$3")
        else
          return value

}

export function formatMesExtenso(value, min) {
  if (!value)
    return ''

  let listMonth = []
  if (min)
    listMonth = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  else
    listMonth = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

  const [year_, month_, day_] = value.split("-")

  let now = new Date
  if (now.getFullYear() == year_)
    return listMonth[month_ - 1]
  else
    return listMonth[month_ - 1] + ' ' + year_

}

export function formatDataExtenso(value, min) {
  if (!value)
    return ''

  const [year_, month_, day_] = value.split("-")
  let day = day_.substr(0, 2)

  if (min)
    return day + ' ' + formatMesExtenso(value, min)
  else {
    var teste = new Date(value);
    var dia = teste.getDay();
    var semana = new Array(6);
    semana[0] = 'Dom';
    semana[1] = 'Seg';
    semana[2] = 'Ter';
    semana[3] = 'Qua';
    semana[4] = 'Qui';
    semana[5] = 'Sex';
    semana[6] = 'Sáb';
    return semana[dia] + ', ' + day + ' ' + formatMesExtenso(value, min)
  }

}

export function formatDataHoraExtenso(value, min) {
  if (!value)
    return ''

  var data = new Date(value);
  var hora = data.toLocaleTimeString()

  return formatDataExtenso(value, min) + ', ' + hora.substr(0, 5)
}

export function formatDataHora(value, min) {
  if (!value)
    return ''

  // var data = new Date(value);

  // var hora = data.toTimeString();

  // return formatDate(value) + ' ' + hora.substr(0, 5

  // Rotina estava convertendo 3 horas a menos do horario do servidor. Pelo horario do browser GTM-0300

  var data = new Date(value);
  var hora = data.getUTCHours();
  var minute = data.getUTCMinutes();

  return formatDate(value) + ' ' + hora + ':' + (minute < 10 ? '0' + minute : minute)
}

export function arrayMoveIndex(arr, old_index, positions) {
  let new_index = old_index + positions

  // console.log(positions)
  // console.log(old_index)
  // console.log(new_index)
  // console.log(arr)

  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  // return arr;
}

export function isValidURLSubdomain(str) {
  var pattern = new RegExp('^((?!-)[A-Za-z0-9-]+[A-Za-z0-9-]+[A-Za-z0-9-](?<!-))$')
  return !!pattern.test(str)
}

export function zeroPad(num, places) {
  return String(num).padStart(places, '0')
}

export function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

export function printForm(prtHtml, mobileDevice) {
  let stylesHtml = '';
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML;
  }

  const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  WinPrint.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        ${stylesHtml}
      </head>
      <body>
        <div>
          <div class="w-100 p-3">
              ${prtHtml}
          </div>
        </div>
      </body>
    </html>
  `);

  WinPrint.document.close();
  WinPrint.focus();
  if (!isMobile()) {
    WinPrint.print();
    // WinPrint.close();
  }

}

/*
export {
   getText,
   formatDate,
   checkDate,
   formatValue,
   formatFone,
   formatCNPJCPF,
   formatMesExtenso,
   formatDataExtenso
}

*/


export function hasHiddenParent(element) {
  while (element && element.parentElement) {
    if ((window.getComputedStyle(element.parentElement).display === 'none') || (jQuery(element.parentElement).prop("tabindex") === 1)) {
      return true
    }
    element = element.parentElement
  }
  return false
}

export function isValidHashColor(color) {
  // Regular expression to match the hex color format
  const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

  // Test if the string matches the regex
  return hexRegex.test(color);
}

export function isValidPostalCode(cep) {
  // Expressão regular para validar o formato do CEP
  const regex = /^[0-9]{5}-?[0-9]{3}$/;
  return regex.test(cep);
}





// WEBPACK FOOTER //
// ./src/shared/utils.js